import React, { useMemo } from 'react';
import { IStyleSettings } from 'types';
import Text from 'components/Text/Text';
import StyleInput from './StyleInput';
import classNames from 'classnames';
import style from './StyleSection.module.scss';

interface IStyleSection {
	keyName: string;
	styleData: { [key: string]: IStyleSettings[] };
	setStyleSettings(styleItemId: string, value: string, key: string): void;
	useCustomerSettings: boolean;
}

const StyleSection: React.FC<IStyleSection> = ({ keyName, styleData, setStyleSettings, useCustomerSettings }) => {
	const countOfItems = useMemo(() => Object.keys(styleData[keyName]).length, [styleData]);
	const containerClasses = classNames({
		[style.forOneItems]: countOfItems === 1,
		[style.forTwoItems]: countOfItems === 2,
		[style.forThreeItems]: countOfItems === 3,
		[style.forFourOrMoreItems]: countOfItems >= 4,
	});

	return (
		<div className={containerClasses}>
			<Text
				className={style.rowName}
				translationNameSpace="mediaSettings"
				translationKey={keyName}
				theme="secondary"
				size="s"
				weight="bold"
			/>
			<div className={style.styleInputWrapper}>
				{styleData[keyName].map((el) => (
					<StyleInput
						setStyleSettings={setStyleSettings}
						data={el}
						countOfItems={countOfItems}
						isDisabled={useCustomerSettings}
						key={el.key}
					/>
				))}
			</div>
		</div>
	);
};

export default StyleSection;
